<h2 mat-dialog-title>
  {{ 'START_TRIAL_MODAL.HEADING' | translate: { numDays: numDaysTrial } }}
</h2>
<mat-dialog-content>
  <p>
    {{ 'START_TRIAL_MODAL.DESCRIPTION' | translate }}
  </p>
  <p>
    {{ 'START_TRIAL_MODAL.DESCRIPTION_2' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    (click)="startTrial(startTrialBtnLoader)"
    [disabled]="startTrialBtnLoader.isLoading && disableButtonWhenLoading"
    mat-flat-button
    color="primary"
  >
    <glxy-button-loading-indicator [isLoading]="startTrialBtnLoader.isLoading">
      {{ 'START_TRIAL_BANNER.START_FREE_TRIAL_BUTTON' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
